module.exports = __webpack_public_path__ + "static/media/cosmetic.f14e200e.jpg";